const sub = encodeURIComponent('IA & Data Science – Sujet 1 – Stage Été 2026');
const body = encodeURIComponent("Bonjour,\n\nJe me permets de vous contacter pour ma candidature au stage d'été 2026.\n\nVeuillez trouver en pièce jointe mon CV et portfolio.\n\nCordialement,\nChaimae Kazoury");
const mailto = `mailto:services.yanecode@gmail.com?subject=${sub}&body=${body}`;

export default function Candidature() {
  return (
    <section id="candidature" style={{ background: '#050a0e', borderTop: '1px solid #1a3040', position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '6rem 3rem', textAlign: 'center' }}>


        <h2 style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', fontWeight: 800, marginBottom: '1.5rem', lineHeight: 1.15, color: '#e2f0f5' }}>
          Candidature YaneCode Digital<br />
          <span style={{ color: '#ff4d6d' }}>Stage Été 2026</span>
        </h2>

        <p style={{ color: '#5a8a9f', fontSize: '0.95rem', lineHeight: 1.9, marginBottom: '2.5rem', maxWidth: 560, marginLeft: 'auto', marginRight: 'auto' }}>
          Je postule au domaine <strong style={{ color: '#e2f0f5' }}>Intelligence Artificielle & Data Science</strong> pour développer un <strong style={{ color: '#e2f0f5' }}>Système IA de monitoring industriel pour la détection d'anomalies et l'alerte temps réel</strong> — un sujet qui correspond exactement à mes projets et compétences actuels.
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center', marginBottom: '3rem' }}>
          {[['Période','Juillet – Août 2026'], ['Domaine','IA & Data Science'], ['Sujet','Sujet 1 — Monitoring IA']].map(([k,v]) => (
            <div key={k} style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.72rem', padding: '0.5rem 1.2rem', border: '1px solid #1a3040', color: '#5a8a9f' }}>
              {k} <strong style={{ color: '#e2f0f5' }}>{v}</strong>
            </div>
          ))}
        </div>


        <div style={{ marginBottom: '1rem' }}>
          <a href={mailto} style={{ fontFamily: "'Space Mono', monospace", fontSize: '1rem', color: '#00e5ff', textDecoration: 'none', borderBottom: '2px solid rgba(0,229,255,0.3)', paddingBottom: 2, transition: 'border-color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#00e5ff'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,229,255,0.3)'}>
            services.yanecode@gmail.com
          </a>
        </div>


      </div>
    </section>
  );
}
